var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEposnowLogoSmallWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_681_89036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.00598145H24V24.006H0V0.00598145Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_681_89036)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3314 22.2396C11.359 22.2396 8.13736 19.1121 8.13736 15.2549C8.13736 11.3983 11.359 8.27077 15.3314 8.27077C17.5914 8.27077 19.6072 9.2825 20.9261 10.8652L12.4802 18.5456C14.5641 20.4489 19.6128 19.9637 20.0152 14.1418L22.4163 14.037C22.4879 14.4322 22.5259 14.8398 22.5259 15.2549C22.5259 19.1121 19.3042 22.2396 15.3314 22.2396M12 0.00598145C5.37258 0.00598145 0 5.3785 0 12.006C0 18.6335 5.37258 24.006 12 24.006C18.6274 24.006 24 18.6335 24 12.006C24 5.3785 18.6274 0.00598145 12 0.00598145",
    fill: "#ffffff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0946 10.808C12.7258 10.9141 10.8047 12.7422 10.8047 14.8897C10.8047 15.4334 10.9281 15.9449 11.1504 16.405L16.8074 11.0534C16.2827 10.8694 15.7037 10.7806 15.0946 10.808",
    fill: "#ffffff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEposnowLogoSmallWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eposnow-logo-small-white.4ec5670c978653a089b8a5996e9eeca0.svg";